export default {
  set(k, v) {
    window.sessionStorage.setItem(k, v)
  },
  get(k) {
    return window.sessionStorage.getItem(k)
  },
  remove(k) {
    window.sessionStorage.removeItem(k)
  },
  clear() {
    window.sessionStorage.clear()
  },
  UrlParm(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.substr(1).match(reg)
    // if (r != null) return unescape(r[2]);
    if (r != null) return decodeURIComponent(r[2])
    return null
  },
  /**
   * 获取接口请求地址
   */
  getBaseUrl(type) {
    const hostname = window.location.hostname
    const arr = hostname.split('.')
    let domain = `${arr[1]}.${arr[2]}`

    const node = process.env.VUE_APP_MODE
    console.log(node)
    if (node === 'development') {
      domain = 'charmplus.cn'
    }
    let nodeUrl = 'test'
    if (node === 'development') {
      nodeUrl = 'prod'
    }
    if (node === 'pre') {
      nodeUrl = 'pre'
    }
    if (node === 'production') {
      nodeUrl = 'prod'
    }
    if (node === 'test') {
      nodeUrl = 'test'
    }
    if (node === 'test1') {
      nodeUrl = 'test-1'
    }
    if (node === 'test2') {
      nodeUrl = 'test-2'
    }

    let baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-ims`
    if (type === 'ims') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-ims`
    }
    if (type === 'report') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-report`
    }
    if (type === 'tea') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-tea`
    }
    if (type === 'iot') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-iot`
    }
    if (type === 'psb') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-psb`
    }
    if (type === 'auth') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-auth`
    }
    if (type === 'oss') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-oss`
    }
    if (type === 'faq') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-faq`
    }
    if (type === 'marketing') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-marketing`
    }
    if (type === 'notice') {
      baseUrl = `wss://gw-${nodeUrl}.${domain}/charmplus-notice/ws/notice/`
    }
    if (type === 'selfterminal') {
      baseUrl = `https://gw-${nodeUrl}.${domain}/charmplus-selfterminal`
    }

    return baseUrl
  }
}
